<template>
  <div class="removable-list">
    <transition-group name="list" tag="div">
      <div v-for="item in items" :key="item.id" class="item">
        <div class="title" :title="item.title">
          {{ item.name }}
          <a @click.prevent="remove(item)">
            <span
              class="af-icons af-icons-close-circle remove not-draggable pull-right"
            ></span>
          </a>
        </div>
        <input
          v-if="itemName"
          type="hidden"
          :name="itemName"
          :value="item[valueProperty]"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: {
    initialItems: {
      type: Array,
      default: () => []
    },
    itemName: {
      type: String,
      default: null
    },
    valueProperty: {
      type: String,
      default: 'value'
    }
  },
  data() {
    return {
      items: []
    };
  },
  watch: {
    initialItems() {
      this.items = this.initialItems;
    }
  },
  created() {
    this.items = this.initialItems;
  },
  methods: {
    getIndex(item) {
      return this.items.map(item => item.id).indexOf(item.id);
    },
    remove(item) {
      const index = this.getIndex(item);

      if (index >= 0) {
        this.items.splice(index, 1);
      }

      this.$emit('removed', item.id);
      this.$emit('change', this.items);
    }
  }
};
</script>

<style scoped>
.list-enter-active {
  transition: all 0.3s;
}
.list-leave-active {
  transition: all 0.3s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
